/**
 * Destino tras entrar con un enlace OTP (`/login/:otp/:next`).
 *
 * Los WhatsApp de recobro de España (ms-ops, oct-2026) llevan un botón «Mi
 * área Life5» con `https://app.life5.es/login/<otp>/pagos`: el cliente tiene
 * que aterrizar en Pagos (`/dashboard/billing`), donde ve sus recibos, los
 * paga y cambia el método de pago. Solo se desvía cuando el destino normal
 * del estado es el dashboard: un lead a medio contratar sigue yendo a su paso.
 */
const DESTINOS: Record<string, string> = {
  pagos: "/dashboard/billing",
};

export const destinoTrasLogin = (destinoDelEstado: string, siguiente?: string): string => {
  const destino = siguiente ? DESTINOS[siguiente] : undefined;
  if (destino && destinoDelEstado.startsWith("/dashboard/")) return destino;
  return destinoDelEstado;
};
